import $ from 'jquery';

//
// Custom site JS goes here
//

(function ($)
{
	if ($)
	{
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
		const mediaBreakpointLg = 992;

		var $window;

		$(function ()
		{
			$window = $(window);

			initNavMenuHover();
			initNavMenuButtons();
			initNavMenuSearch();
			initHashes();
			initSwiperCarousels();
			initFancybox();
			initSearchAndFilter();
			initPostCollections();
			initAnimations();
		});

		function initNavMenuHover()
		{
			$('#primary-header ul.navbar-nav > .dropdown').on('mouseenter', function ()
			{
				if ($window.width() >= mediaBreakpointLg)
				{
					$(this).find('> .dropdown-toggle, > .dropdown-menu').addClass('show');
				}
			});

			$('#primary-header ul.navbar-nav > .dropdown').on('mouseleave', function ()
			{
				if ($window.width() >= mediaBreakpointLg)
				{
					$(this).find('> .dropdown-toggle, > .dropdown-menu').removeClass('show');
				}
			});
		}

		function initNavMenuButtons()
		{
			$('.nav-item-button').each(function (index, element)
			{
				var $navItem = $(element);
				var $navLink = $navItem.find('.nav-link');
				$navLink.removeClass('nav-link').addClass('btn btn-secondary');
			});
		}

		function initNavMenuSearch()
		{
			$('#menu-primary-menu .menu-item-search .nav-link').each(function (index, element)
			{
				var $searchLink = $(element);
				$searchLink.addClass('position-relative');

				var $searchLinkFocusClass = $searchLink.closest('.menu-item'); //$searchLink.closest('#menu-primary-menu');

				var $searchLinkName = $searchLink.find('span');
				var searchLinkNameText = $searchLinkName.text();

				var $searchInput = $('<input class="form-control" type="text" id="searchInputTopMenu" name="s" placeholder="' + searchLinkNameText.toUpperCase() + '" />');

				$searchLink.on('click', function (e)
				{
					if ($window.width() >= mediaBreakpointLg)
					{
						$searchInput.trigger('focus');
						e.preventDefault();
						return false;
					}
				})

				$searchInput.on('focus', function (e)
				{
					$searchLinkFocusClass.addClass('menu-item-search-is-focused');
				});

				$searchInput.on('blur', function (e)
				{
					$searchInput.val('');
					$searchLinkFocusClass.removeClass('menu-item-search-is-focused');
				});

				$searchLinkName.before($searchInput);
			});
		}

		function scrollIntoView($element)
		{
			if ($element && $element.length)
			{
				$element[0].scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
			}
		}

		function initHashes()
		{
			//
			// Swallow window.location.hash changes and smoothly scroll to the target element
			//

			$('a[href*="#"]:not([href="#"])').on('click', function (e)
			{
				if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname)
				{
					var $target = $(this.hash);
					$target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
					if ($target.length)
					{
						scrollIntoView($target);
						return false;
					}
				}
			});
		}

		function initSwiperCarousels()
		{
			// Default options
			var swiperOptions = {
				spaceBetween: 24,
				//slidesPerView: 'auto', //1,
				//watchSlidesProgress: true,
				watchOverflow: true,
				centerInsufficientSlides: true,
				//centeredSlides: true,
				//a11y: false,
			};

			$('.swiper').each(function (index, element)
			{
				// Get main Swiper element
				var $swiper = $(element);
				var $swiperContainer = $swiper.parent('.swiper-container');

				// Get slide count
				var swiperSlideCount = $swiper.find('.swiper-slide').length;

				//
				// Add breakpoint options based on slide count
				//
				// Unfortunately, setting loop mode based on breakpoints is not supported by Swiper.
				// Falling back on enabling loop mode for all breakpoints when there are at least >3 slides.
				//
				var currentSwiperOptions = $.extend({}, swiperOptions, {
					loop: false, //(swiperSlideCount > 3),
				});

				if ($swiperContainer.hasClass('swiper-option-full-width'))
				{
					currentSwiperOptions = $.extend({}, currentSwiperOptions, {
						breakpoints: {
							640: { //768: {
								slidesPerView: Math.min(2, swiperSlideCount),
							},
							992: {
								slidesPerView: Math.min(3, swiperSlideCount),
							},
							1200: {
								slidesPerView: Math.min(4, swiperSlideCount),
							},
							1600: {
								slidesPerView: Math.min(5, swiperSlideCount),
							},
							2160: {
								slidesPerView: Math.min(6, swiperSlideCount),
							},
						},
					});
				}
				else if (!$swiperContainer.hasClass('swiper-option-single-column'))
				{
					currentSwiperOptions = $.extend({}, currentSwiperOptions, {
						breakpoints: {
							768: {
								slidesPerView: Math.min(2, swiperSlideCount),
							},
							992: {
								slidesPerView: Math.min(3, swiperSlideCount),
							},
							1400: {
								slidesPerView: Math.min(4, swiperSlideCount),
							},
						},
					});
				}
				else if ($swiperContainer.hasClass('swiper-option-single-column'))
				{
					currentSwiperOptions = $.extend({}, currentSwiperOptions, {
						loop: true,
					});
				}

				// Add pagination control options
				var $swiperPagination = $swiper.parent().find('.swiper-pagination');
				if ($swiperPagination.length)
				{
					currentSwiperOptions = $.extend({}, currentSwiperOptions, {
						pagination: {
							el: $swiperPagination[0],
							clickable: true
						},
					});
				}

				// Add prev/next nav control options
				var $swiperNavPrev = $swiper.parent().find('.swiper-nav-prev');
				var $swiperNavNext = $swiper.parent().find('.swiper-nav-next');
				if ($swiperNavPrev.length && $swiperNavPrev.length)
				{
					currentSwiperOptions = $.extend({}, currentSwiperOptions, {
						navigation: (swiperSlideCount <= 1) ? false : {
							prevEl: $swiperNavPrev[0],
							nextEl: $swiperNavNext[0]
						},
					});
				}

				// Initialize Swiper
				var swiper = new Swiper(element, currentSwiperOptions);

				//
				// Swiper events
				//

				$swiperContainer.toggleClass('swiper-locked', swiper.isLocked)

				swiper.on('lock', function ()
				{
					$swiperContainer.addClass('swiper-locked');
				});

				swiper.on('unlock', function ()
				{
					$swiperContainer.removeClass('swiper-locked');
				});
			});
		}

		function initFancybox()
		{
			if (typeof Fancybox !== 'undefined' && Fancybox)
			{
				Fancybox.bind("[data-fancybox]", {
					// Your custom options
				});
			}
		}

		function initSearchAndFilter()
		{
			//
			// Search & Filter Pro ajax call start event
			//

			$(document).on("sf:ajaxstart", "form.searchandfilter", function (e)
			{
				var $searchandfilter = $(e.currentTarget);

				// Temporarily disable filters while AJAX results load
				// (They will automatically be re-enabled by the filters returned by Search & Filter Pro)
				$searchandfilter.find('input').attr('disabled', true);
			});

			//
			// Search & Filter Pro ajax call finish event
			//

			$(document).on('sf:ajaxfinish', 'form.searchandfilter', function (e)
			{
				var $searchandfilter = $(e.currentTarget);

				// Scroll results into view
				var $sfAjaxTarget = $($searchandfilter.attr('data-ajax-target'));
				if ($sfAjaxTarget && $sfAjaxTarget.length)
				{
					scrollIntoView($sfAjaxTarget);
				}

				// Init remove filter buttons
				$('button[data-remove-filter-key]').on('click', function (e)
				{
					var $button = $(e.currentTarget);
					var $filters = $searchandfilter.find('[data-sf-field-name="' + $button.attr('data-remove-filter-key') + '"]');
					var $filter = $filters.find('input[value="' + $button.attr('data-remove-filter-value') + '"]');
					if ($filter && $filter.length)
					{
						if ($filter.attr('type') === 'checkbox')
						{
							$filter.trigger('click');
						}
						else
						{
							// TODO: Does this correctly clear other input types?
							$filter.val('');
							$filter.trigger('change');
						}
					}

					$button.remove();
				});
			});
		}

		function initPostCollections()
		{
			var isExpandButtonVisible = true;
			var $expandButton = $('.post-collection-noncarousel-expand-button');

			$expandButton.on('click', function (e)
			{
				isExpandButtonVisible = false;

				$(e.currentTarget).slideUp();
				$('.post-collection-item-hidden:not(.post-collection-item-filtered)').slideDown();

				e.preventDefault();
				return false;
			});

			$('.post-collection-filters').each(function (collectionFiltersIndex, collectionFiltersElement)
			{
				var $filters = $(collectionFiltersElement);
				var $filterCheckboxes = $filters.find('.post-collection-filter input');
				var $filterTarget = $($filters.attr('data-filter-target'));
				var filterAttr = $filters.attr('data-filter-attr');
				var filterNonCarouselInitialCount = parseInt($filters.attr('data-filter-noncarousel-initial-count'));

				$filterCheckboxes.on('change', function (e)
				{
					var currentFilters = '';
					$filterCheckboxes.filter(':checked').each(function (filterIndex, filterElement)
					{
						currentFilters += ',' + $(filterElement).val();
					});

					currentFilters += (currentFilters.length > 0) ? ',' : '';

					var visibleItemCount = 0;
					$filterTarget.find('[' + filterAttr + ']').each(function (targetIndex, targetElement)
					{
						var $item = $(targetElement);
						var isFiltered = (currentFilters.length > 0 && currentFilters.indexOf(',' + $item.attr(filterAttr) + ',') < 0);

						if (isFiltered)
						{
							$item.addClass('post-collection-item-filtered');
							$item.removeClass('post-collection-item-hidden');
						}
						else
						{
							$item.removeClass('post-collection-item-filtered');

							if (isExpandButtonVisible)
							{
								visibleItemCount++;
								$item.toggleClass('post-collection-item-hidden', (visibleItemCount > filterNonCarouselInitialCount));
							}
						}

					});
				});
			});
		}

		function initAnimations()
		{
			//
			// Text fade in effect causing a containing block (i.e. equivalent of position: relative)
			// on the animated elements, which breaks .stretched-link inside of .text-ctas, since
			// .text-ctas becomes the containing block instead of the outer parent element.
			// Removing the animation class after it's done is a bit hacky, but it works.
			//

			// UNDONE: This needs more work. It shouldn't fire until the FINAL child animation is finished,
			// but it fires immediately after the first child animation finishes, which breaks the other animations.

			// $('.has-animation-sequential-text').on('animationend', function (e)
			// {
			// 	$(e.currentTarget).removeClass('has-animation-sequential-text');
			// });


			//
			// Set up animations that won't run until they're in view
			//

			if ('IntersectionObserver' in window)
			{
				$('.has-animation-sequential-fade-text, .has-animation-sequential-fade-cards, .has-animation-image-wipe, .has-animation-image-decoration, .has-animation-slide-in-from-left, .has-animation-slide-in-from-right').each(function (index, element)
				{
					var observerOptions = {
						root: null,
						rootMargin: '0% 0% -10% 0%', //'-50%',//rootMargin: '0px',
						threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
					};

					var observer = new IntersectionObserver(intersectionCallback, observerOptions);

					function intersectionCallback(entries)
					{
						var intersectingCount = 0;
						for (var i = 0; i < entries.length; i++)
						{
							var entry = entries[i];
							if (entry.isIntersecting)
							{
								intersectingCount++;
								$(entry.target).addClass('animation-is-in-view');
							}
						}

						if (intersectingCount === entries.length)
						{
							observer.disconnect();
						}
					}

					observer.observe(element);
				});
			}
		}
	}
}(jQuery));
